module.exports = __webpack_public_path__ + "media/10.ad7f9a4e.mp3";